import type { FunctionComponent } from 'react'
import type { NewsletterSource } from '@which/glide-ts-types'
import { Grid, GridItem, Picture } from '@which/seatbelt'

import classnames from 'classnames'

import type { ImageWithSources } from '../../../generated/frontend'
import { NewsletterSignUp } from '../NewsletterSignUp'
import styles from './NewsletterSignUpWithImage.module.scss'

/*
  In Glide, this can be used at the Collection/Template level
  Known examples:
  -  which.co.uk/topic/test-topic
  -  which.co.uk/money
*/
export const NewsletterSignUpWithImage: FunctionComponent<Props> = ({
  className,
  source,
  image,
  title,
  subtitle,
  cta,
  privacyPolicy,
  withAllFields,
}) => {
  return (
    <Grid
      data-testid="newsletter-signup-with-image"
      className={classnames('w-page-wrapper', styles.newsletterSignUpWithImage)}
    >
      <GridItem
        className={styles.newsletterWrapper}
        span={{ medium: 8, large: 7 }}
        columnStart={{ medium: 1, large: 2 }}
      >
        <NewsletterSignUp
          className={classnames(className, styles.newsletterSignup)}
          source={source}
          title={title}
          subtitle={subtitle}
          cta={cta}
          privacyPolicy={privacyPolicy}
          withAllFields={withAllFields}
        />
      </GridItem>
      <GridItem
        className={styles.imageGridItem}
        span={{ medium: 4, large: 4 }}
        columnStart={{ medium: 9, large: 9 }}
      >
        {image && (
          <div className={styles.imageWrapper}>
            <Picture imageClassName={styles.image} {...image} />
          </div>
        )}
      </GridItem>
    </Grid>
  )
}

export type Props = {
  className?: string
  source: NewsletterSource
  image: ImageWithSources
  title: string
  subtitle: string
  cta: string
  privacyPolicy?: string
  withAllFields: boolean
}
